import { Tag } from "@ugla-france/ugla-3d-library";
import { Immutable } from "immer";

export const getTag = (
  key: string,
  tags: Immutable<Tag[]> | undefined,
  def?: string | undefined
) => {
  const tag = (tags || []).find((tag) => tag.key === key);

  return tag === undefined ? def : tag?.value;
};